import { TableName } from './table-page';

export enum SessionStorage {
  SystemSpecs = 'systemSpecs',
  Token = 'token',
  SiteId = 'siteId',
  CompanyId = 'companyId',
}

export enum LocalStorage {
  RefreshToken = 'refreshToken',
  RefreshExpiration = 'refreshExpiration',
  DeviceToken = 'deviceToken',
  Theme = 'theme',
  Language = 'language',
  LastSiteViewed = 'last-site-viewed',
  LastCompanyViewed = 'last-company-viewed',
  DataUploadAdvancedMode = 'data-upload-advanced-mode',
}

export const TableLayoutLocalStoragePrefix = 'ui:list-layout:v1';

export type SessionStorageTables =
  | TableName.Cars
  | TableName.DriverShifts
  | TableName.Drivers
  | TableName.ExtraServices
  | TableName.Fares
  | TableName.History
  | TableName.Jobs
  | TableName.Locations
  | TableName.Profiles
  | TableName.Rates
  | TableName.Services
  | TableName.Shifts
  | TableName.Shuttles
  | TableName.Suppliers
  | TableName.Trips
  | TableName.Sites
  | TableName.Users;

export type SessionStorageTablesKeys =
  | `table_${SessionStorageTables}`
  | 'jobsProfileHistory'
  | MainListLayoutCacheKey;

export enum MainListLayoutCacheKey {
  Bookings = 'layout_bookings_main',
  Trips = 'layout_trips_main',
  Drivers = 'layout_drivers_main',
  Vehicles = 'layout_vehicles_main',
  DriverShifts = 'layout_driver_shifts_main',
  DriverShiftsWeekly = 'layout_driver_shifts_weekly',
  DriverShiftsTemplates = 'layout_driver_shifts_templates_main',
}
